import {constants} from '@q9elements/ui-kit/common';

export function getPluralSingleMap(invert = false) {
  return constants.singlePluralTypes.reduce((acc, sfType: any) => {
    if (!invert) {
      acc.set(sfType.plural, sfType.single);
      return acc;
    }

    acc.set(sfType.single, sfType.plural);
    return acc;
  }, new Map());
}
